import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { PreferencesToSave } from '@bilancio/api';
import { AuthService } from '@bilancio/auth';
import {
    AsyncActions,
    AuthSelectors,
    CoreActions,
    CoreSelectors,
    SuperStore,
    TsStudioActions,
    TsStudioSelectors,
    UserActions,
    UserSelectors
} from '@bilancio/root-store';
import { firstValueFrom } from 'rxjs';
import {
    ONE_FRONT_BIL_CONFIG,
    OneFrontBilConfig
} from './core/tokens/one-front.token';
import { UsersManagementService } from './manage/users-management/users-management.service';
import { Sandbox } from './utils/sandbox/sandbox-bil.sandbox';

@Injectable()
export class AppSandbox extends Sandbox {
    username$ = this.store.select(AuthSelectors.getUserFirstAndLastName);
    isAdmin$ = this.store.select(AuthSelectors.getUserIsAdmin);
    isViaLiberaDeposit$ = this.store.select(
        AuthSelectors.getIsViaLiberaDeposit
    );
    isLastVersionReaded$ = this.store.select(UserSelectors.isLastVersionReaded);
    showTour$ = this.store.select(UserSelectors.getShowTour);
    isNomeCmd$ = this.store.select(TsStudioSelectors.getNomeCmd);
    licId$ = this.store.select(AuthSelectors.getLicenzaUsoId);
    currentOffice$ = this.store.select(CoreSelectors.getCurrentOffice);
    currentWorkspaceId$ = this.store.select(CoreSelectors.getWorkspaceId);
    getCurrentOffice$ = this.store.select(CoreSelectors.getCurrentOffice);

    constructor(
        protected readonly store: SuperStore,
        private readonly authService: AuthService,
        @Inject(ONE_FRONT_BIL_CONFIG)
        private readonly oneFrontFilConfig: OneFrontBilConfig,
        private readonly userService: UsersManagementService,
        private readonly router: Router
    ) {
        super(store);
    }

    updatePrefs(prefsToSave: PreferencesToSave[]) {
        this.store.dispatch(UserActions.updatePreferences({ prefsToSave }));
    }

    readFeVersion() {
        this.store.dispatch(CoreActions.readFrontendVersion());
    }

    asyncConn() {
        this.store.dispatch(AsyncActions.asyncConnect());
    }

    setNomeCmd() {
        this.store.dispatch(
            TsStudioActions.setNomeCmd({ loginNomeCmd: 'Dusan' })
        );
    }

    readReleaseNote() {
        this.store.dispatch(CoreActions.readReleaseNote());
    }

    cleanState() {
        this.store.dispatch(CoreActions.cleanCoreState());
    }

    logout() {
        this.authService.doLogout();
    }

    async changeOffice(workspaceId: string) {
        const currentWorkspaceId = await firstValueFrom(
            this.currentWorkspaceId$
        );
        const securityToken = localStorage.getItem(
            this.oneFrontFilConfig.storageKey
        );
        if (
            securityToken &&
            workspaceId &&
            workspaceId !== currentWorkspaceId
        ) {
            await this.authService.doLoginDigitalWithToken(
                securityToken,
                workspaceId
            );
            this.userService.flush();
            this.store.dispatch(CoreActions.setWorkspaceId({ workspaceId }));
            await this.router.navigateByUrl('/white', {
                skipLocationChange: true
            });
            this.router.navigate(['/user/dashboard']);
        }
    }
}
